// Shared friendly-message extraction for `ApiError`-shaped failures. The
// dashboard scatters mutation handlers across pages; centralising the copy
// here keeps tone consistent and makes A/B'ing wording cheap. Anything not
// in the map falls through to the raw error message — the caller controls
// the title separately.

import { ApiError } from './api-client.js';

const CODE_COPY: Record<string, string> = {
  plan_limit_exceeded: "You're at your plan limit. Upgrade to keep going.",
  ip_rate_limited: 'Too many requests from this network. Try again in a moment.',
  agent_limit_exceeded: 'Your plan allows fewer agents than this. Upgrade or remove one.',
  invalid_subscription_state:
    'Your subscription state changed. Refresh the page and try again.',
  stripe_not_configured:
    'Stripe billing is not configured on this environment.',
  not_found: 'That item is no longer available.',
  forbidden: 'You do not have permission to perform this action.',
};

export function friendlyError(error: unknown, fallback = 'Something went wrong.'): string {
  if (error instanceof ApiError) {
    if (error.code) {
      const friendly = CODE_COPY[error.code];
      if (friendly) return friendly;
    }
    if (error.message) return error.message;
    return fallback;
  }
  if (error instanceof Error) return error.message || fallback;
  return fallback;
}
